import {Component, OnDestroy, OnInit} from '@angular/core';
import {StyleService} from "./common/services/style.service";
import {style} from "./common/models/style.model";
import {SubSink} from "@Common/core/utils/subsink";



@Component({
  selector: 'app-suaps-inscriptions-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Suaps inscriptions';
  menu = [];
  mainStyle: style = <style>{};
  subSink = new SubSink();
  constructor(private styleService: StyleService) {
  }

  ngOnInit(): void {
    this.subSink.sink = this.styleService.mainStyle$.subscribe((_mainStyle)=> {
     this.mainStyle = _mainStyle;
    });
  }

  ngOnDestroy(): void {
  }

}
